<template>
  <div>
    <input-select-modal
      :title="$t('permission.selectorModal.header')"
      :okButton="$t('commons.save')"
      :cancelButton="$t('commons.cancel')"
      :error="showError"
      :errorMessage="errorMessage"
      :label="$t('permission.selectorModal.selectTarget')"
      :options="targets"
      v-on:cancel="onCancel"
      v-on:ok="onAccept"
      v-model="selectedTarget">
      <div slot="extra" class="margin-bottom-l">
        <checkbox
          class="inline"
          :id="'read'"
          :label="$t('permission.read')"
          checked
          disabled>
        </checkbox>
        <checkbox
          class="inline margin-left-m"
          :id="'edit'"
          @change="canEdit = !canEdit"
          :checked="canEdit"
          :label="$t('permission.edit')">
        </checkbox>
        <checkbox
          class="inline margin-left-m"
          :id="'share'"
          @change="canShare = !canShare"
          :checked="canShare"
          :label="$t('permission.share')">
        </checkbox>
      </div>
    </input-select-modal>
  </div>
</template>

<script>
import Checkbox from '../shared/forms/Checkbox';
import InputSelectModal from '../shared/dialogs/InputSelectModal';

export default {
  name: 'AddPermissionModal',
  components: {
    InputSelectModal,
    Checkbox
  },
  props: {
    targets: {
      type: Array,
      default: () => []
    },
    errorMessage: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      canEdit: false,
      canShare: false,
      selectedTarget: undefined,
      showError: false
    };
  },
  methods: {
    onCancel (event) {
      this.$emit('cancel', event);
    },
    onAccept (event) {
      if (!this.selectedTarget) {
        this.showError = true;
        return;
      }
      this.showError = false;
      this.$emit('addPermission', {target: this.selectedTarget, edit: this.canEdit, share: this.canShare});
    }
  }
};
</script>

<style lang="scss" scoped>
  @import "../../stylesheets/variables.scss";
  .inline {
    display: inline;
  }

  .error-message {
    color: $error;
  }
</style>



// WEBPACK FOOTER //
// src/components/permissions/AddPermissionModal.vue